import { IconButton, styled, Tooltip, Typography } from '@mui/material';
import React from 'react'
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const QuestionHeadingNew = (props:{children:React.ReactNode,type?:string, disableTextTransform?: boolean,description?:string,required?:boolean}) => {
  const {children}=props;
  const Wrapper= styled('div')(`
    font-size:15px;
    text-align:left;
    padding-left:0.2rem;
    font-weight:500;
  margin-bottom: ${ props.type === "toggle" ? "0px" : "8px"};
    text-transform: ${props.disableTextTransform? "none" : "lowercase"};
    &::first-letter {
    text-transform:${props.disableTextTransform? "none" : "capitalize"};
    }
  `)
  return (
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:"8px"}} >
      
    <Wrapper>
        {children}
         {props.required && (
          <Typography
            component="span"
            sx={{ color: "red", ml: "4px" ,mr:"4px"}}
          >
            *
          </Typography>
        )}
    </Wrapper>
   
    {props?.description&&props?.description?.length>0&&
    <Tooltip title={props?.description??""} >
     <InfoOutlinedIcon style={{color:"rgb(34, 124, 157)",opacity: 0.66,height:"18px",width:"18px"}}  fontSize="small" />              
      </Tooltip>
}
    </div>
  )
}

export default QuestionHeadingNew